import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

import { HoverHintWrapper } from '@domain-group/suit-theme'

interface StatusIconProps {
  hint?: string,
  icon: IconProp,
}

const StatusIcon = (props: StatusIconProps) => {
  const { hint, icon } = props

  return (
    <HoverHintWrapper
      boxProps={{
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
        borderRadius: '5px',
        justifyContent: 'center',
        marginLeft: 'small',
        padding: 'small',
      }}
      hintComponent={!!hint && (
        <HoverHintWrapper.Hint>
          {hint}
        </HoverHintWrapper.Hint>
      )}
    >
      <FontAwesomeIcon icon={icon} style={{ color: 'white' }} />
    </HoverHintWrapper>
  )
}

export default StatusIcon
